import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAppContext } from "../../../_context";
import Image from "next/image";
import HighlightedString from "../../Misc/HighlightedString";

const Hero = () => {
  const [{ tx }] = useAppContext();
  const mainContent = (
    <>
      <h1 className="text-black">
        <HighlightedString text={tx["Welcome to the world of [RacketPal]"]} />
      </h1>
      <h4 className="text-black mb-0 fw-normal">
        {
          tx[
            "We’re a crazy passionate bunch dedicated to creating the world’s largest and most engaged racket sports community. We hope you’ll join us – as a member or a teammate. Or both."
          ]
        }
      </h4>
    </>
  );

  return (
    <>
      <section className="hero d-flex align-items-center position-relative overflow-hidden">
        <Image
          src="/img/heroes/about.jpg"
          layout="fill"
          objectFit="cover"
          objectPosition="70%"
          unoptimized={true}
        />
        <div className="w-100 position-relative">
          <Container>
            <Row className="d-flex align-items-center">
              <Col
                md={6}
                lg={5}
                xl={4}
                className="text-white py-5 d-none d-lg-block">
                {mainContent}
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <section className="d-block d-lg-none">
        <Container>
          <Row className="align-items-center">
            <Col lg={5} className="pt-5">
              {mainContent}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Hero;
